export default __webpack_public_path__ + "static/media/avatar_brown_bear8.c57de3d1.mp3";